// Grid configuration constants for signage layout
export const GRID_CONFIG = {
  COLS: 54,
  MAX_ROWS: 54,
  MIN_WIDTH: 1,
  MIN_HEIGHT: 1,
  DEFAULT_COMPONENT_WIDTH: 4,
  DEFAULT_COMPONENT_HEIGHT: 2,
  ROW_HEIGHT_LANDSCAPE: 10,
  ROW_HEIGHT_PORTRAIT: 8
};

// Cache configuration
export const CACHE_CONFIG = {
  MAX_CACHE_SIZE: 50,
  CLEANUP_THRESHOLD: 40
};

// Component type identifiers
export const COMPONENT_TYPES = {
  TIME_COMPONENTS: ['Date and Time(v2)', 'DateAndTime', 'DateLegend'],
  FLOOR_PLAN: 'Floor Plan ',
  BUILDING_INFO: 'Building Info',
  SPACE_CATEGORY: 'Space Category'
};

// Layout constants
export const LAYOUT_CONFIG = {
  DIVIDER_RATIO: 0.75,
  MAGIC_UNUSABLE: 8,
  DEFAULT_MARGINS: {
    X: 4,
    Y: 4
  },
  MIN_DIMENSIONS: {
    WIDTH: 100,
    HEIGHT: 60
  }
};
